import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { toggleAssignableItem } from 'actions/assign';
import ScrollableContainer from 'components/shared/scrollable';
import SelectableItem from './SelectableItem';

class SelectableCollection extends PureComponent {
  constructor(props) {
    super(props);
    this.handleItemClick = this.handleItemClick.bind(this);
    this.renderAssigneeItem = this.renderAssigneeItem.bind(this);
    this.renderContentItem = this.renderContentItem.bind(this);
  }

  static defaultProps = {
    minimumCollapsedCount: 3,
  };

  renderContentItem(item) {
    return (
      <SelectableItem
        key={`${item.type}.${item.id}`}
        label={item.title}
        onClick={() => this.handleItemClick(item)}
      />
    );
  }

  renderAssigneeItem(item) {
    return (
      <SelectableItem
        key={`${item.type}.${item.id}`}
        label={item.name}
        icon={item.type.toLowerCase() === 'group' && 'group'}
        onClick={() => this.handleItemClick(item)}
      />
    );
  }

  renderItems() {
    const { data, name } = this.props;
    switch (name) {
      case 'CONTENT':
        return data.map(this.renderContentItem);
      case 'ASSIGNEES':
        return data.map(this.renderAssigneeItem);
      default:
        return [];
    }
  }

  renderItemsCollapsed() {
    const { minimumCollapsedCount: minCount } = this.props;
    const items = this.renderItems();
    if (items.length > minCount) {
      return [
        items.slice(0, minCount - 1),
        <div key="items:last" className="AssignStep-lastSelectedCollapsed">
          {items.slice(minCount - 1, minCount)}
          <div className="AssignStep-showMore">&#8230;</div>
        </div>,
      ];
    }
    return items.slice(0, minCount);
  }

  handleItemClick(item) {
    this.props.deselectItem(item);
  }

  render() {
    return (
      <div className="AssignStep-selectedItems">
        {!this.props.isActive && this.renderItemsCollapsed()}
        {this.props.isActive && (
          <ScrollableContainer maxHeight={null}>
            {this.renderItems()}
          </ScrollableContainer>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  deselectItem(item) {
    dispatch(toggleAssignableItem(item));
  },
});

const connectMapStateToProps = (state, ownProps) => ({
  isActive: state.activeStep === ownProps.name,
});

export default connect(
  connectMapStateToProps,
  mapDispatchToProps,
)(SelectableCollection);
